import { api } from "./axios";

// ---- Contrasena "Ver datos" (admin, pagina Configuracion) -----------------

export interface ViewCredentialsState {
  configured: boolean;
  updated_at: number;
}

export async function getViewCredentialsState(): Promise<ViewCredentialsState> {
  const r = await api.get("/settings/view-credentials");
  return r.data;
}

export async function setViewCredentialsPassword(password: string): Promise<ViewCredentialsState> {
  const r = await api.put("/settings/view-credentials", { password });
  return r.data;
}

export async function clearViewCredentialsPassword(): Promise<ViewCredentialsState> {
  const r = await api.delete("/settings/view-credentials");
  return r.data;
}

// ---- Revelar credenciales de un dispositivo (boton "Ver datos") -----------

export interface DeviceCredentials {
  username: string;
  password: string;
  host: string;
  http_port: number;
  use_https: boolean;
  web_url: string;
}

export async function revealDeviceCredentials(
  deviceId: number,
  password: string,
): Promise<DeviceCredentials> {
  const r = await api.post(`/devices/${deviceId}/reveal-credentials`, { password });
  return r.data;
}
